import React from 'react';
import  SettingsIcon from '@mui/icons-material/Settings';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FolderIcon from '@mui/icons-material/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListIcon from '@mui/icons-material/List';
import BuildIcon from '@mui/icons-material/Build';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PersonIcon from '@mui/icons-material/Person';
import MailIcon from '@mui/icons-material/Mail';
import CommentIcon from '@mui/icons-material/Comment';
import HistoryIcon from '@mui/icons-material/History';
import TimelineIcon from '@mui/icons-material/Timeline';
import PieChartIcon from '@mui/icons-material/PieChart';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import WorkIcon from '@mui/icons-material/Work';
import CreateIcon from '@mui/icons-material/Create';
import BarChartIcon from '@mui/icons-material/BarChart';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AppsIcon from '@mui/icons-material/Apps';

function loadMaterialIcon(filename, color="inherit") {
    var icon = '';
    switch (filename) {
      case 'EC_EINSTELLUNGEN_64.PNG':
        icon = <SettingsIcon color={color}/>;
        break;
      case 'EC_FORMULARE_SENDEN_64.PNG':
        icon = <CloudUploadIcon color={color}/>;
        break;
      case 'EC_DOKUMENTE_64.PNG':
        icon = <FileCopyIcon color={color}/>;
        break;
      case 'EC_DOKUMENTE_64':
        icon = <FileCopyIcon color={color} />;
        break;
      case 'EC_ARCHIV_64.PNG':
        icon = <FolderIcon color={color}/>;
        break;
      case 'EC_ARCHIV_64':
        icon = <FolderIcon color={color}/>;
        break;
      case 'EC_ENTGELTABRECHNUNG_64.PNG':
        icon = <DescriptionIcon color={color}/>;
        break;
      case 'EC_ADRESSVERWALTUNG_64.PNG':
        icon = <ImportContactsIcon color={color}/>;
        break;
      case 'EC_ABWESENHEIT_64.PNG':
        icon = <EventNoteIcon color={color}/>;
        break;
      case 'CALENDAR.GIF':
        icon = <CalendarTodayIcon color={color}/>;
        break;
      case 'EC_ANWESENHEITSLISTE_64.PNG':
        icon = <ListIcon color={color}/>;
        break;
      case '!32X32/Tools/Setting_Tools':
        icon = <BuildIcon color={color}/>;
        break;
      case 'EC_DATEI_HINZUFUEGEN_64.PNG':
        icon = <CloudUploadIcon color={color}/>;
        break;
      case 'FINGERPRINT_32.GIF':
        icon = <FingerprintIcon color={color}/>;
        break;
      case 'EC_PERSONALINFORMATION_64.PNG':
        icon = <PersonIcon color={color}/>;
        break;
      case 'EMAIL_32.GIF':
        icon = <MailIcon color={color}/>;
        break;
      case '!32X32/Buttons/Comment':
        icon = <CommentIcon color={color}/>;
        break;
      case 'MITARBEITER_ABWESENHEIT.PNG':
        icon = <EventNoteIcon color={color}/>;
        break;
      case 'EC_KALENDER_64.PNG':
        icon = <EventNoteIcon color={color}/>;
        break;
      case 'EC_KORREKTUR_64.PNG':
        icon = <HistoryIcon color={color}/>;
        break;
      case 'INVOICE_32.GIF':
        icon = <DescriptionIcon color={color}/>;
        break;
      case 'CHART 1_32.GIF':
        icon = <PieChartIcon color={color}/>;
        break;
      case 'STATISTIC.GIF':
        icon = <TimelineIcon color={color}/>;
        break;
      case 'EMAIL_INFORMATIONS_32.GIF':
        icon = <MailIcon color={color}/>;
        break;
      case 'EC_DATEI_UEBERMITTLUNG_64.PNG':
        icon = <CloudUploadIcon color={color}/>;
        break;
      case '!32X32/Mail/Vcard_Add':
        icon = <NoteAddIcon color={color}/>;
        break;
      case 'ICONPFLDOKUGELESEN.PNG':
        icon = <LibraryAddCheckIcon color={color}/>;
        break;
      case 'LIGHT_32.GIF':
        icon = <EmojiObjectsIcon color={color}/>;
        break;
      case 'JOURNEY_32.GIF':
        icon = <WorkIcon color={color}/>;
        break;
      case 'EC_STAMMAENDERUNG_64.PNG':
        icon = <CreateIcon color={color}/>;
        break;
      case 'CHART_BAR_32.GIF':
        icon = <BarChartIcon color={color}/>;
        break;
      case 'AWAY.GIF':
        icon = <FlightTakeoffIcon color={color}/>;
        break;
      case 'EC_AU_BESCHEINIGUNG_64.PNG':
        icon = <ReceiptIcon color={color}/>;
        break;
      case 'EC_ZEITERFASSUNG_64.PNG':
        icon = <AccessTimeIcon color={color}/>;
        break;
      case 'EC_ZEITJOURNALE_64.PNG':
        icon = <HistoryIcon color={color}/>;
        break;
      case 'EC_TERMINAUFGABEN_64':
        icon = <EventAvailableIcon color={color}/>;
        break;
      case 'EC_MEINE_AUFGABEN_64.PNG':
        icon = <FormatListBulletedIcon color={color}/>;
        break;
      case 'EC_OFFENE_MELDUNG_64.PNG':
        icon = <NotificationsIcon color={color}/>;
        break;
      case 'EC_PFLICHTDOKUMENT_64.PNG':
        icon = <DescriptionIcon color={color}/>;
        break;
      case '':
        icon = <AppsIcon color={color}/>;
        break;
      default:
        icon = <HelpOutlineIcon color={color}/>;// <Tooltip title={filename}><HelpOutlineIcon/></Tooltip>;
    }
    return icon
}

export default loadMaterialIcon;